<template>
  <div class="page_box">
    <div class="page_option_box">
      <!-- 监控列表 -->
      <el-page-header
        @back="$Common.pageJump('/QuestionBank', 3)"
        content="双重预防考试题"
      >
      </el-page-header>
      <div>
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="add()"
        >
          新增考核题
        </el-button>
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="delBath"
          :disabled="ids.length == 0 ? true : false"
          >删除</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template v-slot="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="questionOrder" label="考核题编号">
          </el-table-column> -->
          <el-table-column prop="topicType" label="考题类型">
            <template v-slot="scope">
              {{ scope.row.topicType == 1 ? "选择题" : "判断题" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="questionContent"
            label="考核题内容"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="questionFraction"
            label="考核题分数"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="addTime"
            label="创建时间"
            width="156"
            align="center"
          >
            <template v-slot="scope">
              {{ $Common.dateFormatDateTwo(scope.row.addTime) }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180" align="center">
            <template v-slot="scope">
              <el-link
                type="primary"
                @click="edit(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                @click="del(scope.row.questionId)"
                :underline="false"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <safety-paper-add
      :addResize="addResize"
      :questionOrder="questionOrder"
      @getList="getList"
    ></safety-paper-add>
    <safety-paper-edit
      :editResize="editResize"
      :paper="paper"
      @getList="getList"
    ></safety-paper-edit>
  </div>
</template>

<script>
import SafetyPaperAdd from "./components/SafetyPaperAdd";
import SafetyPaperEdit from "./components/SafetyPaperEdit";
export default {
  name: "",
  components: {
    SafetyPaperAdd,
    SafetyPaperEdit
  },
  props: {},
  data() {
    return {
      requestData: {
        pageSize: 20,
        pageNum: 1,
        questionOrder: ""
      },
      responseData: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
        pages: 1,
        list: []
      },
      ids: [],
      loading: false,
      dialogVisible: false,
      addResize: 0,
      questionOrder: 0,
      editResize: 0,
      paper: {}
    };
  },
  created() {
    let type = this.$route.query.type;
    this.type = Number(type);
    let id = this.$route.query.id;
    // console.log(id);
    this.questionOrder = Number(id);
    this.requestData.questionOrder = Number(id);
    this.getList();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getList();
    },
    handleSelectionChange(val) {
      this.ids = val.map((element) => {
        return element.questionId;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    add() {
      this.addResize++;
    },
    edit(row) {
      this.paper = row;
      this.editResize++;
    },
    async getList() {
      let requestData = this.requestData;
      this.loading = true;
      let res = await this.$Http.getSafePaper(requestData);
      this.loading = false;
      if (res.code == 200) {
        this.responseData = res.data;
      } else if (res.code == 101) {
        this.responseData = {
          pageSize: 20,
          pageNum: 1,
          total: 0,
          pages: 1,
          list: []
        };
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    del(id) {
      this.$confirm("确定要删除此题目吗？", {
        type: "warning"
      })
        .then(() => {
          this.delSafePaperQuestion([id]);
        })
        .catch(() => {});
    },
    delBath() {
      this.$confirm("确定要删除选中题目吗？", {
        type: "warning"
      })
        .then(() => {
          this.delSafePaperQuestion(this.ids);
        })
        .catch(() => {});
    },
    async delSafePaperQuestion(list) {
      let req = {
        questionIdList: list
      };
      let res = await this.$Http.delSafePaperQuestion(req);
      if (res.code == 200) {
        this.getList();
        this.$message({
          type: "success",
          message: "删除成功"
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.el-date-editor {
  width: 380px;
  height: 28px;
  position: relative;
  top: 3px;
}
</style>
